export default {
  gradientDirectionConfig: {
    defaultGradientDirection: 8,
    shadeValue: 20,
    linearGradientDirection: ['-45deg', '0deg', '45deg', '-90deg', '', '90deg', '-135deg', '180deg', '135deg']
  },
}
